import { useEffect, useReducer } from "react";
import { ObservableReducerStore } from "./hookUtils";

export function useObservableReducer<State, Action extends {type: string}>(store: ObservableReducerStore<State, Action>) {

	const [state, _localDispatch] = useReducer(store.reducer, store.get());

	// Keep global store in sync when local state changes
	useEffect(() => {
		store.set(state);
	}, [state, store]);

	// Sync local state if external store updates it
	useEffect(() => {
		const unsubscribe = store.subscribe((externalState) => {
			_localDispatch({ type: "__sync__", payload: externalState });
		});
		return unsubscribe;
	}, [store]);

	return [state, store.dispatch] as const;
}
